import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/timeoutWith';
import 'rxjs/add/observable/throw';

import { Formulaire } from './formulaire';
import { Pret } from './pret';
import { Personne } from './personne';
import { Garantie } from './garantie';

import { environment } from '../environments/environment';

import { ConnexionService } from './connexion.service';

import { AppGlobal } from './app.global';
import { Information } from './information';

@Injectable()
export class FormulaireService {

  static readonly typeSouscriptionList = [
    {code: 'TR', label: 'NOUVELLE ASSURANCE'},
    {code: 'CH', label: 'CHANGER D\'ASSURANCE'}
  ];
  static readonly typePretList = [
    {code: 'AM', label: 'Amortissable'},
    {code: 'IF', label: 'In fine'},
    {code: 'PT', label: 'Prêt à taux 0'},
    {code: 'PR', label: 'Prêt relais'}
  ];
  static readonly typePretListAviva = [
    {code: 'AM', label: 'Prêt amortissable'},
    {code: 'PT', label: 'Prêt à taux zéro'},
    // {code: 'PR', label: 'Prêt relais'},
    // {code: 'PC', label: 'Prêt Amortissable à capital constant'},
    {code: 'IF', label: 'Prêt in fine'},
    // {code: 'BL', label: 'Crédit Bail et LOA'}
  ];
  static readonly civilityList = [
    {code: 'MR', label: 'Monsieur'},
    {code: 'MME', label: 'Madame'}
  ];
  static readonly professionList = [
    {code: 'AGRI', label: 'Agriculteur'},
    {code: 'ARTI', label: 'Artisan'},
    {code: 'COMM', label: 'Commerçant'},
    // {code: 'ELPO', label: 'Élu - Exposé Politique'},
    {code: 'ENSE', label: 'Enseignant'},
    {code: 'FONA', label: 'Fonctionnaire classe A'},
    {code: 'FHAC', label: 'Fonctionnaire hors classe A - Cadre administratif'},
    {code: 'FHAN', label: 'Fonctionnaire hors classe A - Non cadre administratif'},
    {code: 'INTE', label: 'Intermittent'},
    {code: 'INRI', label: 'Intérimaire'},
    {code: 'OUVR', label: 'Ouvrier'},
    {code: 'PRLI', label: 'Profession libérale'},
    {code: 'RETR', label: 'Retraité'},
    {code: 'SALC', label: 'Salarié cadre'},
    // {code: 'SALN', label: 'Salarié non-cadre'},
    {code: 'SNCE', label: 'Salarié non cadre : Employé'},
    {code: 'SNPI', label: 'Salarié non cadre : Professions intermédiaires'},
    {code: 'SSPR', label: 'Sans profession'},
    {code: 'SPOR', label: 'Sportif professionnel'},
    {code: 'CHEF', label: 'Chef d\'entreprise'}
  ];
  static readonly professionListCafpi = [
    {code: 'AGRI', label: 'Agriculteur'},
    {code: 'ARTI', label: 'Artisan'},
    {code: 'COMM', label: 'Commerçant'},
    {code: 'ENSE', label: 'Enseignant'},
    {code: 'FONA', label: 'Fonctionnaire classe A'},
    {code: 'FHAC', label: 'Fonctionnaire hors classe A - Cadre administratif'},
    {code: 'FHAN', label: 'Fonctionnaire hors classe A - Non cadre administratif'},
    {code: 'INTE', label: 'Intermittent'},
    {code: 'INRI', label: 'Intérimaire'},
    {code: 'OUVR', label: 'Ouvrier'},
    {code: 'PRLI', label: 'Profession libérale'},
    {code: 'RETR', label: 'Retraité'},
    {code: 'SALC', label: 'Salarié cadre'},
    {code: 'SALN', label: 'Salarié non-cadre'},
    {code: 'SSPR', label: 'Sans profession'},
    {code: 'SPOR', label: 'Sportif professionnel'},
    {code: 'CHEF', label: 'Chef d\'entreprise'}
  ];
  static readonly professionListAviva = [
    {code: 'AGRI', label: 'Agriculteur'},
    {code: 'ARTI', label: 'Artisan'},
    {code: 'COMM', label: 'Commerçant'},
    // {code: 'ELPO', label: 'Élu - Exposé Politique'},
    // {code: 'ENSE', label: 'Enseignant'},
    {code: 'FONA', label: 'Fonctionnaire classe A'},
    {code: 'FHAC', label: 'Fonctionnaire Hors Classe A'},
    // {code: 'FHAN', label: 'Fonctionnaire hors classe A - Non cadre administratif'},
    // {code: 'INTE', label: 'Intermittent'},
    // {code: 'INRI', label: 'Intérimaire'},
    {code: 'OUVR', label: 'Ouvrier'},
    {code: 'PRLI', label: 'Profession libérale'},
    {code: 'RETR', label: 'Retraité'},
    {code: 'SALC', label: 'Salarié cadre'},
    // {code: 'SALN', label: 'Salarié non-cadre'},
    {code: 'SNCE', label: 'Salarié non cadre'},
    // {code: 'SNPI', label: 'Salarié non cadre : Professions intermédiaires'},
    {code: 'SSPR', label: 'Sans profession'},
    // {code: 'SPOR', label: 'Sportif professionnel'},
    {code: 'CHEF', label: 'Chef d\'entreprise'}
  ];
  static readonly regimeSocialList = [
    {code: 'SAL', label: 'Salarié'},
    {code: 'FON', label: 'Fonctionnaire'},
    {code: 'TNS', label: 'Travailleur non salarié'},
    {code: 'INA', label: 'Inactif'},
    {code: 'INV', label: 'Investisseur'}
  ];

  static readonly encoursLemoineList = [
    {code: 'UNKOWN', label: 'Je ne sais pas'},
    {code: 'ZERO', label: '0€ (je n’ai pas d’autre emprunt assuré)'},
    {code: 'PLUS200', label: 'Plus de 200k€'}
  ];
  
  
  static readonly objectifPrincipalList = [
    "ADHESION SANS EXAMENS",
    "DOCUMENTS DANS MA LANGUE",
    "AUTRE RISQUE A DECLARER",
    "SUBSTITUTION (dans la 1ere du pret)",
    "SUBSTITUTION (apres 1 an du pret)",
    "OBJECTIF EVOQUE AU TEL",
    "ACCORD POUR UNE MULTI ETUDE",
    "BON RAPPORT QUALITE PRIX",
    "LE TARIF SEUL",
  ];

  static readonly recommandationList = [
    {label: "-- PARRAINAGE CLIENT --"},
    {label: "AUDI Bank"},
    {label: "ARKEA"},
    {label: "BEMO Banque"},
    {label: "BNP"},
    {label: "BNP International buyers"},
    {label: "Banque 1818"},
    {label: "Banque populaire"},
    {label: "Banque Transatlantique"},
    {label: "BC&C"},
    {label: "Bordier et Cie"},
    {label: "BPE"},
    {label: "BRED"},
    {label: "Caisse epargne"},
    {label: "Caisse Epargne Internationale"},
    {label: "CIC"},
    {label: "CIC Banque Privee"},
    {label: "Credit Agricole"},
    {label: "Fortier"},
    {label: "CCF"},
    {label: "LCF Rothschild"},
    {label: "FORTUNIX"},
    {label: "Pierre THUNUS"},
    {label: "NATIXIS"},
    {label: "Societe Generale"},
    {label: "Societe Generale (Clientele Internationale)"},
    {label: "Société Marseillaise de Crédit"},
    {label: "ACE"},
    {label: "ALTHEO PARTNERS"},
    {label: "AMBASSADOR IM"},
    {label: "Artemis Courtage"},
    {label: "AVISOFI"},
    {label: "BFM"},
    {label: "BST Invest"},
    {label: "Cabinet MONTAIGNE"},
    {label: "CAFPI"},
    {label: "CAFPI International"},
    {label: "CAFPI REIMS"},
    {label: "Carte Financement"},
    {label: "CHFS London"},
    {label: "ENNESS France"},
    {label: "Expatrimo HK"},
    {label: "Expatrissimo"},
    {label: "Financez moi / Euodia"},
    {label: "FMD"},
    {label: "FPF (London)"},
    {label: "French Property Consulting (FPC London)"},
    {label: "Helene BRUSSART"},
    {label: "Henry Dannell - Mortgage Solutions"},
    {label: "ICE"},
    {label: "IMMONEOS"},
    {label: "IPF"},
    {label: "Kanope"},
    {label: "MeilleurTaux.com"},
    {label: "My Expat"},
    {label: "My Mortgage in France"},
    {label: "OMF (London)"},
    {label: "PICHET Invest"},
    {label: "Private Rate / Centrale du financement"},
    {label: "Societe2courtage.com"},
    {label: "VIA LA PLATEFORME PATRIMONIALE"},
    {label: "VIA WEALTH MANAGEMENT"},
    {label: "Vous Financer"},
    {label: "Worldwideproperty"},
    {label: "YNVEST"},
    {label: "UFE"},
    {label: "UFE (je suis membre)"},
    {label: "Autre banque"},
    {label: "Autre courtier"},
    {label: "Autre agent immobilier"},
    {label: "Recherche Internet"},
    {label: "Facebook"},
    {label: "Ami"},
    {label: "LAWFORDVIP"},
    {label: "LAWFORD INVESTISSEMENT"}

  ];
  static readonly typeSouscriptionTexts = {
    'CH': {
      economieGainTxt: 'Économie constatée sur le coût total de votre assurance de prêt NaoAssur Emprunteur Equivalence 2. Pour un couple de cadres de 36 ans ayant emprunté 220.000 € sur 20 ans à un taux de 2%, avec une date d\'effet au 15/12/2017.',
      capitalTxt: 'Capital restant dû',
      capitalInfo: "Vous le trouverez sur votre tableau d’amortissement. Prenez celui de l'échéance à laquelle vous pensez changer, par précaution il faut prévoir un délai de mise en place et de substitution auprès de votre organisme prêteur de 3 mois.",
      dureeTxt: 'Durée restante du crédit à date du changement',
      dureeInfo: "Indiquez le nombre de mois restants sur votre crédit à partir de la date souhaitée de changement d’assurance.",
      dateTxt: 'Date de signature initial du prêt',
      dateInfo: "Indiquez le mois et l’année de la signature de votre offre de prêt initiale afin que nous puissions vous estimer l'économie à réaliser en changeant votre contrat d’assurance de prêt avec les contrats d’assurance que nous vous proposerons.",
      etabInfo: 'Choisissez dans la liste déroulante l\'établissement prêteur auprès duquel s\'est faite la souscription du prêt.',
      mentionResultat: 'Cette simulation est indicative et ne constitue pas un engagement contractuel. Elle est calculée sur une estimation du montant de la prime d\'assurance définie lors de la signature de votre offre de prêt, sur la base d\'une reconstitution des conditions de l\'époque, pour l\'établissement auprès duquel a été souscrit le prêt, et sans prise en compte d\'éventuels décotes ou gestes commerciaux dont aurait pu bénéficier le client.',
      formSubtitle: 'SE MUNIR DE L\'OFFRE DE PRÊT',
      garantiesInfo: 'Généralement, la base de garanties DC/PTIA est demandée par les banques pour les investissements locatifs et pour les personnes residant hors d\'Europe. Les garanties IPT/ITT/IPP sont elles, demandees lors de l\'achat d\'une residence principale, pour des residents français ou UE. Se referer au Lexique pour plus d\'information sur les abreviations et garanties possibles.'
    },
    'TR': {
      economieGainTxt: 'Économie constatée sur le coût total d\'une assurance de prêt NaoAssur Emprunteur Equivalence 2, en comparaison avec une offre Groupe, pour un couple de cadres de 36 ans empruntant 220.000 € sur 20 ans à un taux de 2%.',
      capitalTxt: 'Capital emprunté',
      capitalInfo: null,
      dureeTxt: 'Durée du prêt',
      dureeInfo: null,
      dateTxt: 'date d\'effet prévisionnelle de l\'assurance',
      dateInfo: 'Date à laquelle vous pensez débloquer le prêt ou substituer la nouvelle assurance',
      etabInfo: 'Choisissez dans la liste déroulante l\'établissement auprès duquel la souscription du prêt est envisagée.',
      mentionResultat: 'Cette simulation est indicative et ne constitue pas un engagement contractuel. Elle est calculée sur une estimation du montant de la prime d\'assurance définie lors de la signature de votre offre de prêt, sur la base d\'une reconstitution des conditions appliquées par l\'établissement auprès duquel est ou pourrait être souscrit le prêt, et sans prise en compte d\'éventuels décotes ou gestes commerciaux dont pourrait bénéficier le client.',
      formSubtitle: 'SE MUNIR DE L\'OFFRE DE PRÊT',
      garantiesInfo: 'Généralement, la base de garanties DC/PTIA est demandée par les banques pour les investissements locatifs et pour les personnes residant hors d\'Europe. Les garanties IPT/ITT/IPP sont elles, demandees lors de l\'achat d\'une residence principale, pour des residents français ou UE. Se referer au Lexique pour plus d\'information sur les abreviations et garanties possibles.'
    }
  };

  private typeSouscription = FormulaireService.typeSouscriptionList.find(t => t.code === 'TR');
  private form = new Formulaire();
  private redirectionLink;

  public countriesList = null;

  constructor(private http: HttpClient, private connexionService: ConnexionService, private appGlobal: AppGlobal) {
  }

  getTypeSouscription(): any {
    return this.typeSouscription;
  }

  setTypeSouscription(typeSouscription: any) {
    this.typeSouscription = typeSouscription;
  }

  getPrets(): Pret[] {
    return this.form.prets;
  }

  setPret(prets: Pret[]) {
    this.form.prets = prets;
  }

  getPersonnes(): Personne[] {
    return this.form.personnes;
  }

  setPersonnes(personnes: Personne[]) {
    this.form.personnes = personnes;
  }

  getGaranties(): Garantie[] {
    return this.form.garanties;
  }

  setGaranties(garanties: Garantie[]) {
    this.form.garanties = garanties;
  }

  getInformation(): Information {
    return this.form.information;
  }

  setInformation(information: Information) {
    this.form.information = information;
  }

  getPricingInfos(): any {
    return this.form.pricingInfos;
  }

  setPricingInfos(pricingInfos: any) {
    this.form.pricingInfos = pricingInfos;
  }

  getCompanyGroups(): Observable<any> {
    return this.http.get(environment.apiBaseUrl + 'micompany-groups?client=' + environment.codeApporteur, {});
  }

  getCountriesList(): Observable<any> {
    return this.http.get(environment.apiBaseUrl + 'countries', {});
  }

  getCompaniesForCompanyGroup(companyGroupId): Observable<any> {
    return this.http.get(
      environment.apiBaseUrl + 'micompanies',
      {
        params: {
          companyGroupId: companyGroupId
        }
      }
    );
  }

  miseEnRelation(withContact: boolean,im: boolean): Observable<any> {
    const dataToSend = {
      withContact: withContact,
      typeSouscription: this.typeSouscription,
      codeApporteur: this.appGlobal.getCodeApporteur(environment.codeApporteur, window.location.href),
      codeApporteurAuth: this.connexionService.getCodeApporteurAuth(),
      formulaire: this.form,
      other: '',
      origin: this.appGlobal.getOriginUrl(),
      tokenmi: this.appGlobal.getTokenMi(),
      profiles: this.appGlobal.getProfiles(),
      uniqueId: this.appGlobal.getUniqueId()
    };
    if (im) dataToSend.other = 'IMPORT';
    return this.http.post(
      environment.apiBaseUrl + 'mise-en-relation/' + this.getPricingInfos().serviceKey,
      JSON.stringify(dataToSend)
    ).timeoutWith(40000, Observable.throw('Le serveur met un peu de temps à répondre, veuillez réessayer dans quelques instants.'));
  }

  saveDevisPrevoyance(): Observable<any> {
    const data = {
      typeSouscription: this.typeSouscription,
      codeApporteur: this.appGlobal.getCodeApporteur(environment.codeApporteur, window.location.href),
      formulaire: this.form
    };
    return this.http.post(
      environment.apiBaseUrl + 'save-devis-prevoyance/' + this.getPricingInfos().serviceKey,
      JSON.stringify(data)
    ).timeoutWith(40000, Observable.throw('Le serveur met un peu de temps à répondre, veuillez réessayer dans quelques instants.'));
  }

  saveDevis(): Observable<any> {
    this.form.distributor = this.appGlobal.getDistributor();
    this.form.leadCreator = "valorama.fr";
    const data = {
      typeSouscription: this.typeSouscription,
      codeApporteur: this.appGlobal.getCodeApporteur(environment.codeApporteur, window.location.href),
      formulaire: this.form,
      codeApporteurAuth: this.connexionService.getCodeApporteurAuth(),
      origin: this.appGlobal.getOriginUrl(),
      tokenmi: this.appGlobal.getTokenMi(),
      profiles: this.appGlobal.getProfiles(),
      uniqueId: this.appGlobal.getUniqueId()
    };
    return this.http.post(
      environment.apiBaseUrl + 'save-devis-v2',
      JSON.stringify(data)
    ).timeoutWith(40000, Observable.throw('Le serveur met un peu de temps à répondre, veuillez réessayer dans quelques instants.'));
  }

  sendProspectValorama(idGlobalFolder): Observable<any> {
    const contactData = {
      mailTitle: idGlobalFolder,
      formulaire: this.form
    };

    return this.http.post(
      environment.apiBaseUrl + 'sendProspectValorama',
      JSON.stringify(contactData)
    ).timeoutWith(40000, Observable.throw('Le serveur met un peu de temps à répondre, veuillez réessayer dans quelques instants.'));
  }

  contact(): Observable<any> {
    const data = {
      mail:  this.form.personnes[0].email,
      nom: this.form.personnes[0].nom,
      prenom: this.form.personnes[0].prenom
    };
    return this.http.post(
      environment.apiBaseUrl + 'contact-valorama',
      JSON.stringify(data)
    ).timeoutWith(40000, Observable.throw('Le serveur met un peu de temps à répondre, veuillez réessayer dans quelques instants.'));
  }

  reset() {
    this.typeSouscription = FormulaireService.typeSouscriptionList.find(t => t.code === 'CH');
    this.form = new Formulaire();
  }

  getTypeSouscriptionTexts(): any {
      return FormulaireService.typeSouscriptionTexts[this.getTypeSouscription().code];
    
  }

  hasCoEmprunteur() {
    return this.getPersonnes().length > 0;
  }

  setQuotiteBase() {
    let val = 100;
    if (this.hasCoEmprunteur()) {
      val = 50;
      this.getPersonnes()[0].quotite = val;
    }
    //this.getPersonne().quotite = val;
  }

  formatDate(date) : string {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [day, month, year].join('-');
  }
}



// WEBPACK FOOTER //
// ./src/app/formulaire.service.ts